import { SignalingSocket } from 'services/signaling';
import { createRecordingBookmarkRequested } from 'features/recorder/actions';
import { call } from 'redux-saga/effects';

export function* createRecordingBookmarkSaga(
  action: ReturnType<typeof createRecordingBookmarkRequested>
) {
  yield call(SignalingSocket.send, {
    event: 'createRecordingBookmark',
    data: {
      bookmark: action.payload.bookmark,
    },
  });
}
